import { MagicLinkVerifyPage } from "@grafit/frontend-auth/magic-link-verify-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/magic-link")({
  component: MagicLinkVerifyPage,
});
